import axios from 'axios'//引入axios

//创建一个axios实例
let upOss=axios.create({
    headers:{//设置请求头
        
        'Content-Type': 'application/x-www-form-urlencoded',
        // 'Access-Control-Allow-Origin': '*'
        // 'Content-Type': 'application/json',
    }
})

//request拦截器，对请求参数做处理
// getToken.interceptors.request.use(function (config) {
//   //获取token的value
//   let token = window.sessionStorage.getItem("slowing-admin-token")
//   if (token) {
//       //将token放到请求头发送给服务器,将tokenkey放在请求头中
//       config.headers.Authorization = token;     
//       //也可以这种写法
//       // config.headers['accessToken'] = Token;
//        return config;
//   }
// }, function (error) {
//   // Do something with request error
//   return Promise.reject(error);
// });

// 将axios接口暴露出去
export default upOss;


// WEBPACK FOOTER //
// ./src/axios/oss.js